<template>
  <a-modal
      :visible="visible"
      :title="isEdit ? '编辑任务' : '新增任务'"
      @ok="handleOk"
      @cancel="handleCancel"
      destroyOnClose
  >
    <a-form :form="formRef" layout="vertical">
      <a-form-item label="始发地" :rules="[{ required: true, message: '请选择始发地' }]">
        <a-select v-model="form.originId" placeholder="请选择始发地">
          <a-select-option v-for="site in originSiteInfo" :key="site.id" :value="site.id">
            {{ site.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="目的地" :rules="[{ required: true, message: '请选择目的地' }]">
        <a-select v-model="form.destinationId" placeholder="请选择目的地">
          <a-select-option v-for="site in allSiteInfo" :key="site.id" :value="site.id">
            {{ site.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="启用状态" :rules="[{ required: true, message: '请选择启用状态' }]">
        <a-select v-model="form.enable" placeholder="请选择启用状态">
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TransferTaskFormModal",
  props: {
    visible: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    editData: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      form: {
        originId: undefined,
        destinationId: undefined,
        enable: 1
      },
      formRef: this.$form.createForm(this)
    };
  },
  computed: {
    ...mapGetters(["allSiteInfo","userInfo"]),
    // 过滤始发地站点，只显示siteType为'cw'的站点
    originSiteInfo() {
      if (this.userInfo.siteId) {
        // 如果用户有指定的siteId，则只返回匹配该ID的站点信息
        return this.allSiteInfo.filter(site => site.id === this.userInfo.siteId);
      } else {
        // 否则返回所有站点信息
        return this.allSiteInfo;
      }
    }
  },
  watch: {
    editData: {
      handler(val) {
        if (this.isEdit && val) {
          this.form = { ...val };
        }
      },
      immediate: true
    },
    visible(val) {
      if (!val) {
        this.resetForm();
      }
    }
  },
  methods: {
    handleOk() {
      this.formRef.validateFields((err) => {
        if (!err) {
          this.$emit("submit", { ...this.form });
        }
      });
    },
    handleCancel() {
      this.$emit("cancel");
    },
    resetForm() {
      this.form = {
        originId: undefined,
        destinationId: undefined,
        enable: 1
      };
      this.formRef.resetFields();
    }
  }
};
</script>
